import { icon, library, IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'

library.add(fas, far);

export function GetFaIcon(name: IconName, type: IconPrefix) {
  return icon({prefix: type, iconName: name});
}